import { Component, OnInit, inject } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { OrderFinanceService } from '../../../order/order.service';
import { Subscription } from 'rxjs';
import { UtilService } from 'src/app/service/util.service';
import { ShipStation_ShippingRatesData } from 'src/app/models/shipstation/shipstation-shipping-rates-data';
import { DVLService } from 'src/app/service/DVL.service';
import { OrderExtendedInfo } from '../../../order/models/OrderExtendedInfo.model';
import { SelectionExpeditionComponent } from 'src/app/component/expedition/achat-labels/selection-expedition/selection-expedition.component';
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@progress/kendo-angular-dialog';
import { PopUpDialogService } from 'src/app/service/popUpDialog.service';

@Component({
  selector: 'app-shipping-purchase-overview',
  templateUrl: './app-shipping-purchase-overview.component.html',
  styleUrls: ['./app-shipping-purchase-overview.component.scss'],
})
export class appShippingPurchaseOverviewComponent implements OnInit {
  isLoading = false;

  //************************************ */
  //#region  DEPENDENCY INJECTION (DI) -
  private myOrderService = inject(OrderFinanceService);
  private utilService = inject(UtilService);
  public myDVLService = inject(DVLService);
  private matDialog = inject(MatDialog);
  private dialogService = inject(PopUpDialogService);
  //#endregion
  //************************************

  private subscription!: Subscription;

  //************************************
  //#region Variable pour le GRID [pagination, state, et  bla]
  public gridView!: GridDataResult;
  pageable = {
    pageSizes: [10, 25, 50, 100, 500, 1000],
  };
  public state: State = {
    take: 100,
    skip: 0,
    sort: [
      {
        field: 'Shipstation_OrderDate',
        dir: 'desc',
      },
    ],
  };
  public totalItemCount = 0;
  //#endregion
  //************************************

  /** Constructeur */
  constructor() {
    //NOTE : la DI (dependency injection) se fait avec la nouvelle méthode (en tk, as of 2023) avec le verbe inject(module) (voir plus haut)
  }

  ngOnInit(): void {
    //on va chercher le nombre d'élément par page global
    this.state.take = this.utilService.getRowPerPage();

    // fetch product list
    this.refresh();

    // subscribe to data
    this.subscription = this.myOrderService.OrderExtendedInfo.subscribe((response) => {
      this.gridView = {
        data: response.value as OrderExtendedInfo[],
        total: response['@odata.count'],
      };
    });
  }
  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  dataStateChange(state: State) {
    this.state = state;
    this.refresh();
  }

  /** permet de vider les filtres kendo */
  clearFilters(): void {
    this.state.filter = {
      logic: 'and',
      filters: [],
    };
    this.refresh();
  }

  /** Relance le rafraichissement des commandes à partir de oData */
  refresh() {
    this.isLoading = true;
    this.myOrderService.odata_OrderExtendedInfo(this.state).subscribe((response) => {
      this.isLoading = false;
    });
  }

  /** Bouton permettant d'Afficher le pop-up de détail des calculs  */
  OnClickCalcul(currentOrder: OrderExtendedInfo) {
    if (currentOrder == null || currentOrder.ShippingLabel_Buying_LastShippingRatesCalcResults == null) {
      this.dialogService.SimpleErrorAlert('Vous devez absolument saisir un code de produit pour ensuite choisir une DVL.', 'Code de produit invalide');
      return;
    }

    // afficher le  popup
    this.matDialog.open(SelectionExpeditionComponent, {
      data: {
        orderId: currentOrder.shipstation_OrderID,
        CanOrderShipCanBeModified: false,
        ratesData: currentOrder.ShippingLabel_Buying_LastShippingRatesCalcResults,
      },
    });
  }
}
